import UpdateService from "src/services/UpdateService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {};
export const params = {
	content:"",
	heb_date:"",
	img:"",
	type:"",

};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.update,
@property  {array}  modules.updates
**/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {},
	types: types
};
export default ModuleCreator("update", UpdateService, module, types ,params);
